export default class ReadingProgress {
    constructor(element) {
        this.selector = element;

        this.updateProgress();
    }

    updateProgress() {
        const content = document.querySelector('[data-reading-progress-content]');

        if (!content) {
            return;
        }

        window.addEventListener('scroll', () => {
            const contentHeight = document.documentElement.scrollHeight;
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const progress = scrollPosition / (contentHeight - windowHeight);

            this.selector.style.width = `${progress * 100}%`;
        });
    }
}